import {
  getLocalStorageMenuItem,
  getOrderBadgeStatusClass,
  SARIconThemeColor,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileHighlightTextColor,
  setMobileTextColor,
} from "../utility";
import { Badge, Container, Navbar } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";

import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Button } from "@mui/material";
import {
  ArrowBackOutlined,
  CreateOutlined,
  MenuOutlined,
  PaymentOutlined,
  ReceiptOutlined,
  StorefrontOutlined,
  DownloadOutlined,
} from "@mui/icons-material";
import { t } from "i18next";
import ErrorDialog from "../common/errorDialog";
import BottomNavBar from "../components/BottomNavBar";

// Import PDF generation libraries
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useEffect, useState } from "react";
import OrderStatusTracker from "../components/OrderStatusTracker";

const OrderDetails = () => {
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);
  const [params, setParams] = useSearchParams();
  const id = params.get("orderId");

  const { qrName, qrCode } = useParams();

  const navigate = useNavigate();

  const lang = getLocalStorageMenuItem("lang");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);


  // Add this useEffect for responsive detection
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const {
    data: publicData,
    isLoading: publicIsLoading,
    isError: publicIsError,
  } = useQuery("public-order", async () => {
    const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
    const MobileToken = getLocalStorageMenuItem("mobileLoginToken");
    return await axios.get(
      `${process.env.REACT_APP_API
      }/menus/${qrCode}/public-orders?token=${getLocalStorageMenuItem(
        "gustToken"
      )}`,
      { headers: { localization: lang, Authorization: `Bearer ${MobileToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
    );
  });

  const {
    data: detailsData,
    isLoading: detailsIsLoading,
    isError: detailsIsError,
  } = useQuery("public-details-order", async () => {
    try {
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-details`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );

      if (promise?.status === 200) {
        if (!getLocalStorageMenuItem("showOption")) {
          setLocalStorageMenuItem(
            "showOption",
            promise.data.data.mobile_settings?.showOption
          );
        }
        if (promise.data.data.mobile_settings?.theme === "costomize") {
          setLocalStorageMenuItem(
            "theme",
            promise.data.data.mobile_settings?.theme
          );
          setLocalStorageMenuItem(
            "textColor",
            promise.data?.data.mobile_settings.colorProps.text
          );
          setLocalStorageMenuItem(
            "backColor",
            promise.data?.data.mobile_settings.colorProps.back
          );
          setLocalStorageMenuItem(
            "cardColor",
            promise.data?.data.mobile_settings.colorProps.card
          );
          setLocalStorageMenuItem(
            "highlights",
            promise.data?.data.mobile_settings.colorProps.highlights
          );
          setLocalStorageMenuItem(
            "textOnHighlights",
            promise.data?.data.mobile_settings.colorProps.textOnHighlights
          );
        } else {
          if (
            getLocalStorageMenuItem("theme") !== "dark" &&
            getLocalStorageMenuItem("theme") !== "light"
          ) {
            setLocalStorageMenuItem(
              "theme",
              promise.data.data.mobile_settings?.theme
            );
          }
        }
      }
      return promise;
    } catch (error) { }
  });

  const handleBack = () => {
    navigate(
      `/${qrName}/${qrCode}/orders?section=${urlParam.get(
        "section"
      )}&t=${urlParam.get("t")}`
    );
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  const downloadInvoicePDF = async () => {
    try {
      const pdfContent = document.createElement('div');
      pdfContent.className = "alignByLang";
      pdfContent.style.width = '80mm';
      pdfContent.style.backgroundColor = '#ffffff';
      pdfContent.style.color = '#000000';
      pdfContent.style.fontFamily = 'Arial, sans-serif';
      pdfContent.style.fontSize = '12px';
      pdfContent.style.lineHeight = '1.4';
      pdfContent.style.padding = '10px';
      pdfContent.style.boxSizing = 'border-box';

      // Get current date
      const currentDate = new Date().toLocaleDateString(lang === 'ar' ? 'ar-EG' : 'en-US');

      // Calculate total amount
      const totalAmount = (order?.final_total || 0);

      // Create compact receipt content
      pdfContent.innerHTML = `
      <div style="text-align: center; margin-bottom: 15px; border-bottom: 1px dashed #333; padding-bottom: 10px;">
        <h2 style="margin: 0 0 5px 0; font-size: 16px; font-weight: bold;">${detailsData?.data.data?.venu_name || 'Restaurant'}</h2>
        <div style="font-size: 9px; color: #666;">${currentDate}</div>
      </div>

      <!-- Order Info -->
      <div style="margin-bottom: 10px; font-size: 11px;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Order number :")}</span>
          <span style="font-weight: bold;">#${order?.order_id}</span>
        </div>
        ${detailsData?.data.data?.table ?
          `
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Table")}:</span>
          <span>${detailsData?.data.data?.table || ''}</span>
        </div>
          `
          :
          ``
        }

        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Order Time :")}</span>
          <span>${order?.time}</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Customer Name :")}</span>
          <span>${order?.customer}</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Status")}:</span>
          <span style="font-weight: bold;">${t(order?.status) || ""}</span>
        </div>
      </div>

      <!-- Items -->
      <div style="border-top: 1px dashed #333; border-bottom: 1px dashed #333; padding: 8px 0; margin-bottom: 10px;">
        <div style="font-weight: bold; font-size: 11px; margin-bottom: 5px; text-align: center;">${t("Items Ordered")}</div>
        ${order?.items?.map(item => `
          <div style="margin-bottom: 8px; font-size: 10px;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start;">
              <div style="flex: 1; margin-right: 5px;">
                <div style="font-weight: bold; margin-bottom: 2px;">${item.name}</div>
                ${item.notes ? `<div style="color: #666; font-size: 9px; margin-bottom: 2px;">${t("Notes")}: ${item.notes.replace(/\/\//g, ', ')}</div>` : ''}
              </div>
              <div style="text-align: right; min-width: 40px;">
                <div>${item.qty}x</div>
                <div style="font-weight: bold;">${item.price} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</div>
              </div>
            </div>
          </div>
        `).join('') || ''}
      </div>

      ${order?.note ? `
      <div style="margin-bottom: 10px; font-size: 10px;">
        <div style="font-weight: bold; margin-bottom: 3px;">${t("Customer Notes")}:</div>
        <div style="color: #666; font-style: italic;">${order.note}</div>
      </div>
      ` : ''}

      <!-- Payment Summary -->
      <div style="margin-bottom: 10px; font-size: 11px;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Subtotal")}:</span>
          <span>${order?.the_sub_total || 0} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Items Discount")}:</span>
          <span>${order?.the_items_discount || 0} - ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>
        
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Tax")}:</span>
          <span>${order?.the_tax || 0} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>

        <p style=" border-bottom: 1px dashed #333; padding: 2px 0; margin-bottom: 2px;width:50%;margin:auto;" />
        
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Total")}:</span>
          <span>${order?.the_total || 0} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Delivery Amount")}:</span>
          <span>${order?.the_delivery_amount || 0} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>
        ${order?.the_delivery_discount > 0 ?
          `
        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Delivery Discount")}:</span>
          <span>${order?.the_delivery_discount || 0} - ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>
        `
          :
          ``

        }

        <div style="display: flex; justify-content: space-between; margin-bottom: 3px;">
          <span>${t("Delivery Tax")}:</span>
          <span>${order?.the_delivery_tax || 0} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
        </div>
        <div style="border-top: 1px solid #333; margin-top: 5px; padding-top: 5px;">
          <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 12px;">
            <span>${t("End Total")}:</span>
            <span>${Number(order?.the_final_total).toFixed(2)} ${detailsData?.data.data.currency_symbol === "SAR" ? t("SAR") : detailsData?.data.data.currency_symbol || ""}</span>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 5px; font-size: 10px;">
          <span>${t("Payment Method")}:</span>
          <span>${order?.payment_method}</span>
        </div>
      </div>

      <!-- Footer -->
      <div style="text-align: center; margin-top: 15px; padding-top: 10px; border-top: 1px dashed #333; font-size: 9px; color: #666;">
        <div style="margin-bottom: 3px;">${t("Thank you for Choosing us!")}</div>
        <div>${detailsData?.data.data?.venu_name || ''}</div>
      </div>
    `;

      // Add to body temporarily
      document.body.appendChild(pdfContent);

      // Generate canvas with higher quality for small receipt
      const canvas = await html2canvas(pdfContent, {
        scale: 3, // Higher scale for crisp text on small format
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: pdfContent.scrollWidth,
        height: pdfContent.scrollHeight
      });

      // Remove temporary element
      document.body.removeChild(pdfContent);

      // Create PDF in receipt format (80mm width)
      const imgData = canvas.toDataURL('image/png', 1.0);

      // Convert 80mm to points (1mm = 2.834645669 points)
      const receiptWidth = 80 * 2.834645669; // ~226.77 points
      const imgWidth = receiptWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Create custom size PDF
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [receiptWidth, Math.max(imgHeight + 20, 400)] // Min height 400pt
      });

      // Add image to PDF with some padding
      pdf.addImage(imgData, 'PNG', 10, 10, imgWidth - 20, imgHeight);

      // Generate filename
      const filename = `Receipt_${order?.order_id}_${new Date().toISOString().slice(0, 10)}.pdf`;

      pdf.save(filename);

    } catch (error) {
      console.error('Error generating receipt PDF:', error);
      alert(t("Error generating PDF. Please try again."));
    }
  };

  if (publicIsLoading || detailsIsLoading) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  if (publicIsError || detailsIsError) {
    return <ErrorDialog />;
  }

  const index = publicData?.data.data.orders.findIndex(order => Number(order?.order_id) === Number(id));
  const order = publicData?.data.data.orders[index];

  return (
    <div
      className={`min-vh-100`}
      style={{ backgroundColor: setMobileBackColor() }}
    >
      <Container fluid>

        <div className="row">


          <div className={`${isDesktop ? '' : 'col-lg-4 '}ms-auto p-0`}>
            <div className={`${isDesktop ? 'container' : ''} mobile-side-screen`} style={{ marginBottom: "65px" }}>
              <Navbar
                className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav`}
                style={{
                  width: "100%",
                  margin: "auto",
                  backgroundColor: setMobileCardColor(),
                }}
              >
                <Button
                  onClick={handleBack}
                  style={{ color: setMobileTextColor() }}
                >
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                </Button>

                <Navbar.Brand className="head-font text-center m-0">
                  <p
                    className="mb-1 text-center sub-font"
                    style={{ color: setMobileTextColor() }}
                  >
                    {detailsData.data.data?.table}
                  </p>
                </Navbar.Brand>

              </Navbar>

              <div className="mx-2 alignByLang" style={{ marginTop: "64px" }}>


                {order?.status_array && (
                  <div
                    className="m-top-12  rounded-4"
                    style={{
                      border: `1px solid ${setMobileCardBorderColor()}`,
                      backgroundColor: setMobileCardColor(),
                    }}
                  >
                    <OrderStatusTracker
                      statuses={order?.status_array || []}
                      textColor={setMobileTextColor()}
                      accentColor={setMobileButttonBackColor()}
                    />
                  </div>
                )}



                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2
                    style={{ color: setMobileTextColor() }}
                    className="sub-font font-size-22 mb-4"
                  >
                    <StorefrontOutlined
                      style={{ color: setMobileTextColor() }}
                      fontSize="large"
                    />
                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >{`${t("Delivry from")} (${detailsData?.data.data.venu_name
                      })`}</span>
                  </h2>
                  <div className="d-flex justify-content-between">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order Location :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order?.location ? order?.location : ""}
                    </span>
                  </div>
                </div>
                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <h2
                      style={{ color: setMobileTextColor() }}
                      className="sub-font font-size-22 mb-4"
                    >
                      <ReceiptOutlined
                        style={{ color: setMobileTextColor() }}
                        fontSize="large"
                      />
                      <span
                        className="mx-2"
                        style={{ color: setMobileTextColor() }}
                      >
                        {t("Order details")}
                      </span>
                    </h2>

                    <p className="mb-2 alignByLang">
                      <Badge
                        className={` ${getOrderBadgeStatusClass(
                          order?.status
                        )} p-2 font-size-12 sub-font m-1`}
                      >{t(order?.status) || ""}
                      </Badge>
                    </p>
                  </div>

                  <div className="d-flex justify-content-between">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order number :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      #{order?.order_id}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Order Time :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order.time}
                    </span>
                  </div>
                  <div
                    style={{
                      borderBottom: `1px solid ${setMobileCardColor()}`,
                    }}
                    className="d-flex justify-content-between mt-2 pb-2"
                  >
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Customer Name :")}
                    </span>
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="head-font"
                    >
                      {order.customer}
                    </span>
                  </div>
                  {order?.items.map((item) => (
                    <div
                      className="pb-2"
                      style={{
                        borderBottom: `1px solid ${setMobileCardColor()}`,
                      }}
                    >
                      <div
                        key={item.id}
                        className="d-flex justify-content-between mt-2 pb-2"
                      >
                        <span
                          style={{ color: setMobileTextColor(), width: "30%" }}
                          className="sub-font"
                        >
                          {item.name}
                        </span>
                        <span
                          style={{ color: setMobileTextColor() }}
                          className="head-font"
                        >
                          {item.qty}
                        </span>
                        <span
                          style={{ color: setMobileTextColor() }}
                          className="head-font"
                        >
                          {item.price} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}

                        </span>
                      </div>
                      {item.notes && (
                        <div>
                          <span
                            className="head-font"
                            style={{ color: setMobileButttonBackColor() }}
                          >
                            {t("Comments")}
                          </span>
                          <p
                            className="sub-font"
                            style={{ color: setMobileTextColor() }}
                          >
                            {item.notes.split("//").map((element, index) => (
                              <p
                                key={index}
                                className="font-size-16 cursor mb-1"
                                style={{
                                  color: order.price_changed
                                    ? "#F04438"
                                    : setMobileTextColor(),
                                }}
                              >
                                {element}
                              </p>
                            ))}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div
                  className="m-top-12 p-24 rounded-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2
                    style={{ color: setMobileTextColor() }}
                    className="sub-font font-size-22"
                  >
                    <CreateOutlined style={{ color: setMobileTextColor() }} fontSize="large" />
                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >
                      {t("Customer Notes")}
                    </span>
                  </h2>
                  <p style={{ color: setMobileTextColor() }}>{order.note}</p>
                </div>
                <div
                  className="m-top-12 p-24 rounded-4 mb-4"
                  style={{
                    border: `1px solid ${setMobileCardBorderColor()} `,
                    backgroundColor: setMobileBackColor(),
                  }}
                >
                  <h2 className="sub-font font-size-22 mb-4">
                    {" "}
                    <PaymentOutlined
                      style={{ color: setMobileTextColor() }}
                      fontSize="large"
                    />{" "}

                    <span
                      className="mx-2"
                      style={{ color: setMobileTextColor() }}
                    >
                      {t("Pay Details")}
                    </span>

                  </h2>
                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Payment method")}
                    </span>

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {order.payment_method}
                    </span>
                  </p>
                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Subtotal")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_sub_total).toFixed(2)} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Items Discount")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_items_discount).toFixed(2)} - {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Tax")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_tax).toFixed(2)} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "1px 0", paddingTop: "1px" }}></p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Total")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_total).toFixed(2)} {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Delivery Amount")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_delivery_amount).toFixed(2)}  {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Delivery Discount")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_delivery_discount).toFixed(2)} - {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>

                  <p className="font-size-18 d-flex justify-content-between sub-font primary-color">
                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {t("Delivery Tax")}
                    </span>{" "}

                    <span
                      style={{ color: setMobileTextColor() }}
                      className="sub-font"
                    >
                      {Number(order.the_delivery_tax).toFixed(2)}  {detailsData?.data.data.currency_symbol ? detailsData?.data.data.currency_symbol === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : detailsData?.data.data.currency_symbol : ""}
                    </span>

                  </p>
                  <p style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "1px 0", paddingTop: "1px" }}></p>


                  {order.the_final_total > 0 && (
                    <p className="font-size-18 d-flex justify-content-between blue-color head-font primary-color">
                      <span style={{ color: setMobileTextColor() }} className="head-font">{t("End Total")}</span>{" "}
                      <span style={{ color: setMobileTextColor() }} className="head-font">
                        {order.the_final_total}
                      </span>
                    </p>
                  )}

                </div>

                <div className="d-flex justify-content-center mb-3">
                  <Button
                    className="head-font"
                    onClick={downloadInvoicePDF}
                    style={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileHighlightTextColor(),
                      padding: '12px 24px',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      textTransform: 'none',
                      fontSize: '14px'
                    }}
                    startIcon={<DownloadOutlined />}
                  >
                    {t("Download order details")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <BottomNavBar qr={qrCode} qrName={qrName} />

    </div>
  );
};

export default OrderDetails;
